import React, { useState } from 'react';
import {
  List,
  UrlField,
  TextField,
  useNotify,
  useRefresh,
  Filter,
  SearchInput,
} from 'react-admin';

import withStyles from '@material-ui/core/styles/withStyles';
import {
  Button,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';

import { ZippityDatagrid } from '../../components';

import { apiPut } from '../../brainApi';
import { perPage, possibleProStatuses } from '../../helper';

const listStyles = {};

const ChangeStatusButton = ({ selectedIds }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const handleSubmit = async () => {
    const payload = selectedIds
      .map((pro_name) => ({
        pro_name,
        status: possibleProStatuses[selectedStatus],
      }))
      .filter((e) => !!e.status);

    const updatedPros = (await apiPut('/bulk-update-pro', payload)) || [];

    setEditModalIsOpen(false);
    if (updatedPros.Status === 'Failure') {
      notify(`Failed to update status of ${selectedIds.length} Pros.`);
    } else {
      notify(
        `Successfully updated status of ${updatedPros.length} of ${selectedIds.length} Pros.`,
      );
      refresh();
    }
  };

  return (
    <>
      <Button onClick={() => setEditModalIsOpen(true)}>
        <EditIcon style={{ marginRight: '7px' }} />
        Change Status
      </Button>

      <Dialog open={editModalIsOpen}>
        <DialogTitle>{`Change Status for ${selectedIds.length} Pros`}</DialogTitle>
        <DialogContent>
          <Select
            id="pro_statuses"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            fullWidth
          >
            {Object.entries(possibleProStatuses).map(([status, label]) => (
              <MenuItem key={status} value={status}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditModalIsOpen(false)} color="primary">
            Close
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleSubmit}
            disabled={false}
          >
            <CheckIcon style={{ marginRight: '7px' }} />
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const ProFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

export const ProList = withStyles(listStyles)(({ classes, ...props }) => (
  <div>
    <List
      {...props}
      title="Zippity Pros"
      filters={<ProFilter />}
      sort={{ field: 'pro_name', order: 'ASC' }}
      perPage={perPage}
      bulkActionButtons={<ChangeStatusButton />}
    >
      <ZippityDatagrid>
        <TextField source="created_at" />
        <TextField source="pro_name" />
        <TextField source="customer_facing_name" />
        <UrlField source="booking_url" target="_blank" />
        <TextField source="tech_app_account_name" />
        <TextField source="status" />
      </ZippityDatagrid>
    </List>
  </div>
));
